import apiSip from 'api/sip';
import { DOMAIN_MEETING } from 'constants/api';

const ROOM_ID_PATTERN = /^\d{10}$/;
const SIP_ADDRESS_PATTERN = /^[A-Za-z0-9_.+*-]+@[A-Za-z0-9.-]+(?::[0-9]+)?$/;

export const CALLED_ROOM_ERROR_CODES = {
    INVALID_RESPONSE: 'CALLED_ROOM_INVALID_RESPONSE',
    REQUEST_FAILED: 'CALLED_ROOM_REQUEST_FAILED',
    POPUP_BLOCKED: 'POPUP_BLOCKED'
};

const createCalledRoomError = code => {
    const error = new Error(code);
    error.code = code;
    return error;
};

const isValidSipAddress = value => typeof value === 'string'
    && SIP_ADDRESS_PATTERN.test(value);

const hasBusinessDetail = error => {
    const responseDetail = error?.response?.data?.detail_err;
    const directDetail = error?.detail_err;

    return (typeof responseDetail === 'string' && responseDetail.length > 0)
        || (typeof directDetail === 'string' && directDetail.length > 0);
};

export const buildCalledRoomUrl = ({ roomId, sipAddress, shouldAutoInvite }, meetingUrl = DOMAIN_MEETING) => {
    const baseUrl = String(meetingUrl).replace(/\/+$/, '');
    const roomUrl = `${baseUrl}/${encodeURIComponent(roomId)}`;

    if (!shouldAutoInvite) {
        return roomUrl;
    }

    return `${roomUrl}?sip=true&autoCallSip=${encodeURIComponent(sipAddress)}`;
};

export const openCalledRoom = async (sipUser, roomName, meetingUrl = DOMAIN_MEETING) => {
    const target = window.open('', '_blank');

    if (!target) {
        throw createCalledRoomError(CALLED_ROOM_ERROR_CODES.POPUP_BLOCKED);
    }

    try {
        const response = await apiSip.resolveCalledRoom(sipUser, roomName);
        const calledRoom = response?.data;
        const validRoom = response?.status === 200
            && typeof calledRoom?.roomId === 'string'
            && ROOM_ID_PATTERN.test(calledRoom.roomId);
        const validSipAddress = !calledRoom?.shouldAutoInvite
            || isValidSipAddress(calledRoom?.sipAddress);

        if (!validRoom || !validSipAddress) {
            throw createCalledRoomError(CALLED_ROOM_ERROR_CODES.INVALID_RESPONSE);
        }

        target.location.href = buildCalledRoomUrl(calledRoom, meetingUrl);

        return calledRoom;
    } catch (error) {
        target.close();

        if (error?.code === CALLED_ROOM_ERROR_CODES.INVALID_RESPONSE) {
            throw error;
        }

        if (hasBusinessDetail(error)) {
            throw error;
        }

        throw createCalledRoomError(CALLED_ROOM_ERROR_CODES.REQUEST_FAILED);
    }
};
